import { StrictStyleOptions } from 'botframework-webchat-api';

export default function createErrorBoxStyle({ monospaceFont, primaryFont }: StrictStyleOptions) {
  return {
    // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
    display: 'flex',
    flexDirection: 'column',
    fontFamily: primaryFont,
    margin: 0,
    minHeight: 20,
    maxHeight: 200,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',

    '& > :first-child': {
      backgroundColor: '#B60000', // WCAG AAA: Contrast ratio >= 7:1.
      color: 'White',
      padding: '5px 10px'
    },

    '& > :last-child': {
      borderColor: '#B60000', // WCAG AAA: Contrast ratio >= 7:1.
      borderStyle: 'dashed',
      borderBottomWidth: 2,
      borderLeftWidth: 2,
      borderRightWidth: 2,
      borderTopWidth: 0,
      margin: 0,
      overflowY: 'auto',
      padding: 10,

      '& > pre': {
        fontFamily: monospaceFont,
        fontSize: '60%',
        margin: 0
      }
    }
  };
}
